import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnChanges,
  ChangeDetectorRef,
} from '@angular/core';

@Component({
  selector: 'app-three-sixty-viewer-modal-body',
  templateUrl: './three-sixty-viewer-modal-body.component.html',
  styleUrls: ['./three-sixty-viewer-modal-body.component.scss'],
})
export class ThreeSixtyViewerModalBodyComponent implements OnChanges {
  @Input() images: string[] = [];
  @Output() closeEmitter = new EventEmitter<void>();
  @Input() init = false;
  @ViewChild('wrapper') wrapperRef!: ElementRef;

  shouldRender = false;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(): void {
    if (this.init && !this.shouldRender) {
      this.shouldRender = true;
      this.enterFullscreen();
      this.cdr.detectChanges();
    }
  }

  enterFullscreen(): void {
    const el = this.wrapperRef?.nativeElement;
    if (!el) return;

    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if ((el as any).webkitRequestFullscreen) {
      (el as any).webkitRequestFullscreen();
    }
  }

  close(): void {
    this.closeEmitter.emit();
  }
}
